var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFaulted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-check-circle 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-check-circle",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF00D",
    transform: "translate(5.125000, 4.875000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3632812,2.36328125 C13.6210938,2.07682292 13.75,1.74739583 13.75,1.375 L13.75,1.375 C13.75,1.00260417 13.6210938,0.673177083 13.3632812,0.38671875 C13.0768229,0.12890625 12.7473958,0 12.375,0 C12.0026042,0 11.6731771,0.12890625 11.3867188,0.38671875 L6.875,4.94140625 L2.36328125,0.38671875 C2.07682292,0.12890625 1.74739583,0 1.375,0 C1.00260417,0 0.673177083,0.12890625 0.38671875,0.38671875 C0.12890625,0.673177083 0,1.00260417 0,1.375 C0,1.74739583 0.12890625,2.07682292 0.38671875,2.36328125 L4.94140625,6.875 L0.38671875,11.3867188 C0.12890625,11.6731771 0,12.0026042 0,12.375 C0,12.7473958 0.12890625,13.0768229 0.38671875,13.3632812 C0.673177083,13.6210938 1.00260417,13.75 1.375,13.75 C1.74739583,13.75 2.07682292,13.6210938 2.36328125,13.3632812 L6.875,8.80859375 L11.3867188,13.3632812 C11.6731771,13.6210938 12.0026042,13.75 12.375,13.75 C12.7473958,13.75 13.0768229,13.6210938 13.3632812,13.3632812 C13.6210938,13.0768229 13.75,12.7473958 13.75,12.375 C13.75,12.0026042 13.6210938,11.6731771 13.3632812,11.3867188 L8.80859375,6.875 L13.3632812,2.36328125 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFaulted);
export default __webpack_public_path__ + "static/media/ic-faulted.2f3fbacdd04b8c538f90e76a747e65f7.svg";
export { ForwardRef as ReactComponent };